"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BetPanelView = void 0;
const NolimitApplication_1 = require("@nolimitcity/slot-launcher/bin/NolimitApplication");
const NolimitPromotionPlugin_1 = require("../NolimitPromotionPlugin");
const PromoPanelAssetConfig_1 = require("../config/PromoPanelAssetConfig");
const PromoPanelLabelIDs_1 = require("../enums/PromoPanelLabelIDs");
const ImgLoader_1 = require("@nolimitcity/slot-launcher/bin/loader/ImgLoader");
const BetDisplay_1 = require("./BetDisplay");
const PlusMinusWidget_1 = require("./PlusMinusWidget");
const CurrencyUtils_1 = require("../utils/CurrencyUtils");
class BetPanelView extends PIXI.Container {
    constructor(incrementBtnId, decrementBtnId, buttonClickCallback, bgTint) {
        super();
        this._formatValueAsCurrency = true;
        this._betBackground = new PIXI.NineSlicePlane(ImgLoader_1.ImgLoader.getImgTexture(PromoPanelAssetConfig_1.PromoPanelAssetConfig.BET_PANEL_BG), 16, 16, 16, 16);
        this._betBackground.tint = bgTint;
        this._betBackground.alpha = 0.8;
        this._betDisplay = this.createBetDisplay();
        this._betSelector = this.createBetSelector(incrementBtnId, decrementBtnId, buttonClickCallback);
        this.addChild(this._betBackground);
        this.addChild(this._betDisplay, this._betSelector);
        this.resize(NolimitApplication_1.NolimitApplication.isLandscape);
    }
    get betDisplay() {
        return this._betDisplay;
    }
    get betSelector() {
        return this._betSelector;
    }
    setBackgroundAlpha(value) {
        this._betBackground.alpha = value;
    }
    resize(isLandscapeLayout) {
        if (isLandscapeLayout) {
            this.setBackgroundSize(280, 264);
            this._betDisplay.position.set(this._betBackground.width * 0.5, 34);
            this._betSelector.position.set(this._betBackground.width * 0.5, 188);
        }
        else {
            this.setBackgroundSize(633, 153);
            this._betDisplay.position.set(this._betBackground.width * 0.5 - 170, 31);
            this._betSelector.position.set(this._betBackground.width * 0.5 + 170, 77);
        }
        this._betDisplay.resize();
    }
    setValue(value) {
        this._value = value;
        if (this._formatValueAsCurrency) {
            this._betDisplay.setValue(CurrencyUtils_1.CurrencyUtils.formatWithDecimalCutOff(this._value));
        }
        else {
            this._betDisplay.setValue("" + value);
        }
    }
    getValue() {
        return this._value;
    }
    setBackgroundSize(width, height) {
        this._betBackground.width = width;
        this._betBackground.height = height;
    }
    createBetDisplay() {
        return new BetDisplay_1.BetDisplay(NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.translations.translate(PromoPanelLabelIDs_1.PromoPanelLabelIDs.BET));
    }
    createBetSelector(incrementBtnId, decrementBtnId, buttonClickCallback) {
        return new PlusMinusWidget_1.PlusMinusWidget(incrementBtnId, decrementBtnId, buttonClickCallback);
    }
}
exports.BetPanelView = BetPanelView;
//# sourceMappingURL=BetPanelView.js.map